import React, { useState } from "react";
import { toast } from "sonner";
import { Link2 } from "lucide-react";

const SHARE_BASE = "https://shadowspeakjournal.com/api/blog/paths";

// Anonymous share card: no names or reading data, just the path.
export default function PathShareCard({ path }) {
  const [copied, setCopied] = useState(false);
  const url = `${SHARE_BASE}/${path.id}/share`;
  const text = `I walked the Umbra shadow work path · ${path.essays.length} essays`;
  const enc = encodeURIComponent;
  const links = [
    { id: "x", label: "X", href: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}` },
    { id: "facebook", label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { id: "linkedin", label: "LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}` },
  ];
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied.");
    } catch {
      toast.error("Couldn't copy — long-press the link instead.");
    }
  };
  const btn = "inline-flex items-center gap-2 border border-obsidian-600 hover:border-terracotta hover:text-terracotta text-bone-300 px-4 min-h-[40px] font-sans text-xs uppercase tracking-[0.2em] transition-colors";

  return (
    <div className="mb-8" data-testid={`path-share-card-${path.id}`}>
      <img
        src={`/share/path-${path.id}.jpg`}
        alt={`${text} — ${path.name}`}
        className="w-full border border-obsidian-600 mb-4"
        loading="lazy"
        data-testid="path-share-image"
      />
      <p className="font-sans text-sm text-bone-400 mb-4">Share the path, not your answers. The card carries no name or reading data.</p>
      <div className="flex flex-wrap gap-2">
        {links.map((l) => (
          <a key={l.id} href={l.href} target="_blank" rel="noopener noreferrer" className={btn} data-testid={`path-share-${l.id}`}>
            {l.label}
          </a>
        ))}
        <button type="button" onClick={copy} className={btn} data-testid="path-share-copy">
          <Link2 className="h-3.5 w-3.5" /> {copied ? "Copied" : "Copy link"}
        </button>
      </div>
    </div>
  );
}
